import type { NavigationItemBase, URLGenerationStrategy } from "@/domains/navigation/navigation-item"

export class DynamicURLStrategy implements URLGenerationStrategy {
  generateHref(item: NavigationItemBase): string {
    let href = item.href

    // Replace dynamic parameters with actual values
    if (href.includes(":address")) {
      // This would need to be injected through a custom strategy
      // For now, return the href as-is
      return href
    }

    if (href.includes(":id")) {
      // This would need to be injected through a custom strategy
      // For now, return the href as-is
      return href
    }

    return href
  }
}
